/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  const Sage = {
    // All pages
    common: {
      init() {
        // JavaScript to be fired on all pages

        const daterange = getUrlParameter('daterange');
        const subscriptions = getUrlParameter('subscriptions');

        // ////
        // Expand and contract mischiefs //
        // ////
        const elems = $(
          'article.mischiefs, .mischief--view-button, .mischief--view-button-arrow'
        );
        const button = $('.mischief--view-button');
        const title = $('.mischief--title');

        // Do not expand and contract on single views
        if (!$('body').hasClass('single')) {
          elems.addClass('closed');
          button.on('click', toggleVisibility);
          title.on('click', toggleVisibilityTopic);
        } else {
          $('.mischief--view-button').hide();
        }

        function toggleVisibilityTopic() {
          if ($(this).closest('article.mischiefs').hasClass('closed')) {
            $(this)
              .closest('article.mischiefs')
              .find('.mischief--view-button')
              .click();
          }
        }

        function toggleVisibility() {
          const mischief = $(this).closest('article.mischiefs');
          const thisElems = mischief
            .find('.mischief--view-button, .mischief--view-button-arrow')
            .andSelf();
          if (thisElems.hasClass('closed')) {
            thisElems.removeClass('closed');
            thisElems.addClass('open');
          } else {
            thisElems.removeClass('open');
            thisElems.addClass('closed');
          }
        }

        // ////
        // Menu tabs //
        // ////
        $('.header--menu-item').on('click', function () {
          if (
            $(this).data('href') &&
            window.location.href !== $(this).data('href')
          ) {
            window.location.href = $(this).data('href');
          } else if (!$(this).hasClass('open')) {
            if (
              $(this).data('target') !== 'subscriptions' &&
              subscriptions &&
              APIHELPER.show_subscriptions === 'true'
            ) {
              $('.content > .main').addClass('hidden');
            } else $('.content > .main').removeClass('hidden');
            toggleOpenMenuItem($(this));
          }
        });
        // Click some of the tabs in the beginning
        if (daterange) {
          toggleOpenMenuItem($(".header--menu-item[data-target='time']"));
        } else if (subscriptions && APIHELPER.show_subscriptions === 'true') {
          toggleOpenMenuItem(
            $(".header--menu-item[data-target='subscriptions']")
          );
        } else if ($(".header--menu-item[data-target='search']")) {
          toggleOpenMenuItem($(".header--menu-item[data-target='search']"));
        }

        function toggleOpenMenuItem(element) {
          element.addClass('open').siblings().removeClass('open');
          const target = element.attr('data-target');
          $(`#${target}`).addClass('open').siblings().removeClass('open');
          // Bring search buttons and filters along.
          $('#search-additionals').appendTo(`[data-destination=${target}]`);
        }

        // ////
        // SHOW OR HIDE ADDITIONAL SEARCH FIELDS //
        // ////
        if ($('#search-additional').is(':checked')) {
          $('.search--additional-fields').addClass('visible');
        }
        $('#search-additional').on('click', function () {
          if ($('.search--additional-fields').hasClass('visible')) {
            $('.search--additional-fields input:checkbox').removeAttr(
              'checked'
            );
          }
          $('.search--additional-fields').toggleClass('visible');
        });

        // ////
        // User Menu //
        // ////
        $('svg.close-button, svg.user').on('click', function () {
          const overlay = $('aside.user');
          if (!overlay.hasClass('open')) {
            overlay.addClass('open');
          } else if (overlay.hasClass('open')) {
            overlay.removeClass('open');
          }
        });

        // ////
        // Date Range Picker //
        // ////
        moment.locale('fi');
        let startDate = false;
        let endDate = false;
        if (daterange) {
          // Account for different urlencoding
          if (daterange.indexOf('+') >= 0) {
            startDate = daterange.split('+', 1)[0];
            endDate = daterange.split('+')[2];
          } else {
            startDate = daterange.split(' ', 1)[0];
            endDate = daterange.split(' ')[2];
          }
        }
        $('input[name="daterange"]').daterangepicker(
          {
            locale: {
              direction: 'ltr',
              separator: ' - ',
              applyLabel: 'OK',
              cancelLabel: 'Peruuta',
              weekLabel: 'vko',
              customRangeLabel: 'Aikav\u00e4li',
              daysOfWeek: moment.weekdaysMin(),
              monthNames: moment.monthsShort(),
              firstDay: 1,
              format: 'D.M.YYYY',
              separator: ' - ',
              toLabel: '-',
              daysOfWeek: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
              monthNames: [
                'Tammi',
                'Helmi',
                'Maalis',
                'Huhti',
                'Touko',
                'Kes\u00e4',
                'Hein\u00e4',
                'Elo',
                'Syys',
                'Loka',
                'Marras',
                'Joulu',
              ],
            },
            startDate: startDate || moment().weekday(1).format('D.M.YYYY'),
            endDate: endDate || moment().weekday(7).format('D.M.YYYY'),
            showISOWeekNumbers: true,
            opens: 'center',
          },
          function (start, end, label) {}
        );

        // Utility function to get daterange for search purposes
        function getUrlParameter(sParam) {
          const sPageURL = decodeURIComponent(
            window.location.search.substring(1)
          );
          const sURLVariables = sPageURL.split('&');
          let sParameterName;
          let i;

          for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : sParameterName[1];
            }
          }
        }
        // ////
        // Linkify //
        // ////
        $('article').linkify({
          target: '_blank',
        });

        // ////
        // API subscribe/unsubscribe calls
        // ////

        const { siteurl } = APIHELPER;
        const subscribe_settings = {
          api_base: `${siteurl}/wp-json/${APIHELPER.api_subscribe}/`,
          nonce: APIHELPER.nonce,
          endpoints: {
            subscribe: {
              route: 'subscribe/',
              method: 'POST',
            },
          },
        };

        $('a[data-api-button=true]').on('click', function (e) {
          e.preventDefault();
          const post_id = $(this).data('api-post-id');
          const action = $(this).data('api-action');
          const user_id = $(this).data('api-user-id');
          $(this).addClass('disabled');
          subscribe($(this), post_id, action, user_id);
        });

        function doAjax(endpoint, data, cb) {
          return $.ajax({
            url: subscribe_settings.api_base + endpoint.route,
            method: endpoint.method,
            beforeSend(xhr) {
              xhr.setRequestHeader('X-WP-Nonce', subscribe_settings.nonce);
            },
            data,
          }).done(function (data) {
            cb(data);
          });
        }

        function subscribe(element, post_id, action, user_id) {
          return doAjax(
            subscribe_settings.endpoints.subscribe,
            {
              action,
              id: post_id,
              user_id,
            },
            function (response) {
              element.removeClass('disabled');
              if (response) {
                changeSubscribeElementStatus(element, post_id, action);
              } else {
                // TODO: proper error msg
                alert(
                  'Tapahtui virhe, yritä hetken kuluttua uudelleen! Jos ongelma jatkuu, ota yhteyttä sivuston ylläpitäjään, kiitos!'
                );
              }
            }
          );
        }

        function changeSubscribeElementStatus(element, post_id, action) {
          if (action === 'subscribe') {
            element.text(APIHELPER.unsubscribe);
            element.data('api-action', 'unsubscribe');
          } else if (action === 'unsubscribe') {
            const subscriptions_open = $(
              'li[data-target="subscriptions"]'
            ).hasClass('open');
            const element_to_remove = $(`article[class^="post-${post_id}"]`);
            if (element_to_remove.length === 1 && subscriptions_open) {
              element_to_remove.fadeOut('slow', function () {
                element_to_remove.remove();
              });
            } else {
              element.text(APIHELPER.subscribe);
              element.data('api-action', 'subscribe');
            }
          }
        }
        $('a[data-action="mischief--key_people_more_info"]').click(function (
          e
        ) {
          e.preventDefault();
          $(this).toggleClass('open');
          $(this)
            .siblings('[data-class="mischief--key_people_more_info"]')
            .toggleClass('open');
        });
      },
      finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init() {
        // JavaScript to be fired on the home page
      },
      finalize() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init() {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire(func, funcname, args) {
      let fire;
      const namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
